import * as Yup from 'yup';

export const specialNumberSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    pattern: Yup.string().required('Pattern is required'),
    isActive: Yup.boolean().default(true),
});
